import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HittingMonitor as NyyHittingMonitor, defaultHittingMonitorFilter, dateTranslate, number, baseEvent, hitType,
    pitchTypeDisplayName } from 'yankees-react-utils';
import { usePitchVideoFn, useMultiVideoFn } from '../../../../data';
import ReportCard from '../../../../components/ReportCard';
import { VideoPlayerModal } from '../../../../components/VideoPlayer';

const PitchLocation = ({ modalContainer, isLhb, batter, pitches, catchers, teams, pitcher }) => {
    const { t: translate } = useTranslation();
    const pitchVideoFn = usePitchVideoFn();
    const multiVideoFn = useMultiVideoFn();

    const [pitchLocationFilter, setPitchLocationFilter] = useState({
        ...defaultHittingMonitorFilter,
        batterHand: isLhb ? 2 : 1,
        pitcherHand: pitcher.Throws,
    });

    const tooltipFormatter = (series, point) => {
        const pitch = pitches.find((p) => p.gameid === point.gameid && p.eventseq === point.eventseq && p.pitchseq === point.pitchseq);

        const result = pitch.resultid;
        const catcher = catchers.find((c) => c.catcherid === pitch.catcherid);
        const vsteam = teams.find((t) => t.TeamID === pitch.vsteamid);

        return `<b>${series.name}</b><br />${`${translate('common.date')}: `}
            ${dateTranslate(translate, pitch.gamedate)}<br />${translate('sections.opponent.player.caught')}/${translate('sections.opponent.player.against')}: 
            ${catcher?.catchername}${vsteam ? `/${vsteam?.FullName}` : ''}<br />`
            + `${translate('data.pitch-type')}: ${pitchTypeDisplayName(pitch, false, false, translate)}<br />${
                pitch.initspeed54 ? `${translate('format.abbr-mph', { value: number(pitch.initspeed54, 0) })}<br/>` : ''
            }${pitch.istop ? `${translate('baseball.abbr-top')} ` : `${translate('baseball.abbr-bottom')} `}${pitch.inning}, ${
                pitch.outs} ${translate('baseball.outs', { count: pitch.outs })}, ${
                pitch.balls}-${pitch.strikes
            }<br />${translate('baseball.pitcher_one')}: ${pitcher.FullName} (${pitch.islhp ? 'L' : 'R'}) ${pitch.islastpitch && (result === 14 || result === 15)
                ? `<br />${hitType(pitch.hittype, false, translate)} ${baseEvent(pitch.baseevent, undefined, undefined, translate)}${pitch.bip
                    ? `, ${translate('sections.opponent.player.exit-velo')} ${pitch.exitvelo ? number(pitch.exitvelo) : '--'}` : ''}`
                : ''}`;
    };

    return (
        <ReportCard
            title={`${translate('sections.opponent.player.pitch-location')} ${translate('baseball.abbr-versus')} 
            ${isLhb ? translate('baseball.lhh') : translate('baseball.rhh')}`}
        >
            <NyyHittingMonitor
                isLoading={false}
                liveFilter={pitchLocationFilter}
                setLiveFilter={setPitchLocationFilter}
                pitches={pitches}
                pitchVideoFn={pitchVideoFn}
                multiVideoFn={multiVideoFn}
                videoPlayerModal={VideoPlayerModal}
                modalContainer={modalContainer}
                hideSprayChart
                hideEvLaChart
                hideBatterHand
                hidePerspectiveToggle
                hideLastPAs
                player={batter}
                tooltipFormatter={tooltipFormatter}
                enablePlayAllInStatsTable
            />
        </ReportCard>
    );
};

export default PitchLocation;
